module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e856e10ea83d2383f39ec9b6ba70115f.png";